export default __webpack_public_path__ + "static/media/Wedding wire.a954f562.webp";